
<div class="shopReviewScore">
  <div class="shopReviewScore__item">
    <div class="shopReviewScore__title">満足度平均</div>
    <div class="shopReviewGraph">
      <donut-chart :rating="totalAverageRating"></donut-chart>
      <slider-chart :rating-counts="ratingCounts"></slider-chart>
    </div>
  </div>
  <div class="shopReviewScore__item">
    <div class="shopReviewScore__title">各項目の評価</div>
    <div class="shopReviewRating">
      <div class="shopReviewRating__item" v-for="(label, rating) in ratingLabels" :key="rating">
        <div class="shopReviewRating__label">{{ label }}</div>
        <div class="shopReviewRating__rating">{{ ratingAverages[rating] ? ratingAverages[rating].toFixed(1) : '-' }}</div>
      </div>
    </div>
  </div>
</div>
